<script lang="ts">
    const supporterForm = {
        image: "image/common/supporter-form-qr.png",
        url:   "https://forms.gle/qugKz7bbndH9r1bf8"
    }
</script>

<sction id="support-activity-section">
    <div class="container">
        <h2 class="container__title">支援活動</h2>
        <ul class="container__content-area">  
            <li class="container__content-item">
                <div class="container__content-label">東邦銀行</div>
                <div class="container__content-text">会津アピオ支店（店番号：422）</div>
            </li>
            <li class="container__content-item">
                <div class="container__content-label">普通預金</div>
                <div class="container__content-text">口座番号：
                    <span class="container__content-text--important">214094</span>
                </div>
            </li>
            <li class="container__content-item">
                <div class="container__content-label">名義</div>
                <div class="container__content-text">ﾀﾅｶﾘｮｳｽｹﾌｯｶﾂｵｳｴﾝﾌﾟﾛｼﾞｪｸﾄ</div>
            </li>
            <div class="container__content-caution">※ATMからのお振込時、名義の字数に制限があるためできるところまでご入力ください。</div>
            <div class="container__content-form">
                <div class="container__content-form-text">以下のQRコード、またはボタンから<br>涼介に応援メッセージを<br>よろしくお願いいたします。</div>
                <div class="container__content-form-image-area">
                    <img class="container__content-form-image" alt="応援フォームのQRコード" src="{supporterForm.image}">
                </div>
                <div class="container__content-form-button">
                    <a class="container__content-form-button--link" href="{supporterForm.url}">支援者情報のご入力</a>
                </div>
            </div>
        </ul>
    </div>
</sction>

<style>
    #support-activity-section {
        display:          block;
        padding:          40px 0;
        background-color: #f0eee9;
    }

    #support-activity-section .container {
        margin:  0 auto;
        padding: 16px;
    }

    #support-activity-section .container__title{
        font-size:   30px;
        font-weight: bold;
        color:       #1a2382;
        margin:      0 0 56px;
    }
    
    #support-activity-section .container__title:after {
        display:          block;
        position:         absolute;
        content:          "";
        height:           4px;
        width:            25%;
        background-color: #1a2382;
        transform:        translate(132%, 16px);
    }

    #support-activity-section .container__content-area {
        display:          block;
        margin:           0;
        padding:          32px 20px;
        background-color: white;
        border-radius:    8px;
        text-align:       left;
    }

    #support-activity-section .container__content-item {
        list-style: none;
    }

    #support-activity-section .container__content-item:nth-child(-n+2) { /* nth-child(-n+2)でn番目まで */
        margin-bottom: 32px;
    }

    #support-activity-section .container__content-item:nth-child(3) {
        margin-bottom: 16px;
    }

    #support-activity-section .container__content-label {
        display:          inline-block;
        width:            96px;
        margin-bottom:    8px;
        text-align:       center;
        font-size:        18px;
        background-color: #1e1b79;
        color:            white;
        border-radius:    4px;
    }

    #support-activity-section .container__content-text {
        display:     inline-block;
        width:       100%;
        font-size:   20px;
        font-weight: bold;
        text-align:  center;
    }

    #support-activity-section .container__content-text--important {
        padding-left: 16px;
        font-size:    26px;
        color:        #2b2797;
    }

    #support-activity-section .container__content-caution {
        margin-bottom: 40px;
        text-align:    center;
        font-size:     16px;
    }

    /* form area ----------------------------------- */

    #support-activity-section .container__content-form {
        display: block;
    }

    #support-activity-section .container__content-form-text {
        margin-bottom: 16px;
        font-size:     18px;
        font-weight:   bold;
        color:         #353535;
        text-align:    center;
    }

    #support-activity-section .container__content-form-button {
        text-align: center;
    }

    #support-activity-section .container__content-form-button a {
        padding:          8px 32px;
        font-size:        24px;
        font-weight:      bold;
        color:            white;
        border-radius:    8px;
        background-color: #ebaa06;
        transition:       0.8s;
    }

    #support-activity-section .container__content-form-button a:hover {
        text-decoration: none;
    }

    #support-activity-section .container__content-form-button a:active {
        opacity:    0.6;
        transition: 0.1s;
    }

    #support-activity-section .container__content-form-image-area {
        width:         100%;
        margin-bottom: 24px;
        text-align:    center;
    }

    #support-activity-section .container__content-form-image {
        width:  150px;
        height: 150px;
    }
</style>